<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="625"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          {{ form.id === '' ? 'Tambah' : 'Ubah' }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <ValidationObserver 
            ref="form">
            <v-form>
              <ValidationProvider 
                name="name" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Nama Lengkap
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save()"
                  style="max-width: 70%; border-radius: 10px;"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details

                  class="mb-6"
                  :color="set_color"
                  placeholder="Contoh. John Doe"
                  
                  v-model="form.name"
                  vvvv-uppercase
                  :success="form.name !== '' && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nama Lengkap {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.name !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="username" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Username
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save()"
                  style="max-width: 50%; border-radius: 10px;"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details

                  class="mb-6"
                  :color="set_color"
                  placeholder="Contoh. johndoe"
                  
                  v-model="form.username"
                  vvvv-uppercase
                  :success="form.username !== '' && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Username {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.username !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="code" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Nomor Induk Pegawai
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save()"
                  style="max-width: 40%; border-radius: 10px;"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details

                  class="mb-6"
                  :color="set_color"
                  placeholder="Contoh. 001"

                  @blur="fetchCheck(form.code)"
                  
                  v-model="form.code"
                  vvvv-uppercase
                  :success="form.code !== '' && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nomor Induk Pegawai {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.code !== '' && check_code.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nomor Induk Pegawai {{ check_code }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.code !== '' && valid && check_code.length < 1">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="email" 
                rules="required|email" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Email
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save()"
                  style="max-width: 60%; border-radius: 10px;"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details

                  class="mb-6"
                  :color="set_color"
                  placeholder="Contoh. johndoe@gmail.com"
                  
                  v-model="form.email"
                  vvvv-uppercase
                  :success="form.email !== '' && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Email {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.email !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="mobilephone" 
                rules="required|min:8|max:13" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Telepon
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save()"
                  style="max-width: 50%; border-radius: 10px;"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details

                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"
                  
                  class="mb-6"
                  :color="set_color"
                  placeholder="Contoh. 081332XXXXXX"
                  
                  v-model="form.mobilephone"
                  vvvv-uppercase
                  :success="form.mobilephone !== '' && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Telepon {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.mobilephone !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="birthplace" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Tempat Lahir
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save()"
                  style="max-width: 70%; border-radius: 10px;"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details

                  class="mb-6"
                  :color="set_color"
                  placeholder="Contoh. Yogyakarta"
                  
                  v-model="form.birthplace"
                  vvvv-uppercase
                  :success="form.birthplace !== '' && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Tempat Lahir {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.birthplace !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <div>
                <div class="body-2 mb-2">
                  Tanggal Lahir
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>

                <v-menu
                  ref="birth"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker.birth">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="birthdate" 
                      v-slot="{ errors, valid }">
                      <v-text-field
                        v-on:keyup.enter="save"
                        readonly
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="Contoh. 1992-12-12"
                        hide-details
                        clearable

                        @click:clear="form.birthdate = ''"
                        v-on="on"
                        v-bind="attrs"

                        v-model="form.birthdate"
                        :success="form.birthdate !== '' && valid"
                        :error-messages="errors"
                        class="mb-6"
                        style="border-radius: 10px; width: 50%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Tanggal Lahir {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.birthdate !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-date-picker 
                    :color="set_color"
                    v-model="form.birthdate"
                    @input="picker.birth = false">
                  </v-date-picker>
                </v-menu>
              </div>

              <ValidationProvider 
                name="gender" 
                rules="required"
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Jenis Kelamin
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-select
                  v-on:keyup.enter="save()"
                  style="max-width: 50%; border-radius: 10px;"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. Laki-Laki"
                  hide-details
                  
                  :items="[
                    {
                      text: 'Laki-Laki',
                      value: 'Laki-Laki'
                    },
                    {
                      text: 'Perempuan',
                      value: 'Perempuan'
                    }
                  ]"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="form.gender"
                  :success="form.gender !== '' && valid"
                  :error-messages="errors">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Jenis Kelamin {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.gender !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <ValidationProvider 
                name="blood_group" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Golongan Darah
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>

                <v-select
                  v-on:keyup.enter="save()"
                  style="max-width: 40%; border-radius: 10px;"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. O"
                  hide-details
                  
                  :items="[
                    {
                      text: 'O',
                      value: 'O'
                    },
                    {
                      text: 'A',
                      value: 'A'
                    },
                    {
                      text: 'B',
                      value: 'B'
                    },
                    {
                      text: 'AB',
                      value: 'AB'
                    }
                  ]"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="form.blood_group"
                  :success="form.blood_group !== '' && valid"
                  :error-messages="errors">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Golongan Darah {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.blood_group !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <ValidationProvider 
                name="address" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Alamat
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-textarea
                  v-on:keyup.enter="save()"
                  style="border-radius: 10px;"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details

                  rows="3"

                  class="mb-6"
                  :color="set_color"
                  placeholder="Contoh. Jl. Pemuda No. 01"
                  
                  v-model="form.address"
                  vvvv-uppercase
                  :success="form.address !== '' && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Alamat {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.address !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-textarea>
              </ValidationProvider>

              <ValidationProvider 
                name="nik" 
                rules="min:16|max:16" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Nomor Induk Kependudukan
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save()"
                  style="max-width: 60%; border-radius: 10px;"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details

                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"
                  
                  class="mb-6"
                  :color="set_color"
                  placeholder="Contoh. 3310062XXXXXX"
                  
                  v-model="form.nik"
                  vvvv-uppercase
                  :success="form.nik !== '' && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nomor Induk Kependudukan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.nik !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="npwp" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  NPWP
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save()"
                  style="max-width: 60%; border-radius: 10px;"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details

                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"
                  
                  class="mb-6"
                  :color="set_color"
                  placeholder="Contoh. 00.000.000.0-000.000"
                  
                  v-model="form.npwp"
                  vvvv-uppercase
                  :success="form.npwp !== '' && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        NPWP {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.npwp !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="bpjs_kes" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  BPJS Kesehatan
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save()"
                  style="max-width: 60%; border-radius: 10px;"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details

                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"
                  
                  class="mb-6"
                  :color="set_color"
                  placeholder="Contoh. 492010XXXXX"
                  
                  v-model="form.bpjs_kes"
                  vvvv-uppercase
                  :success="form.bpjs_kes !== '' && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        BPJS Kesehatan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.bpjs_kes !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="bpjs_tk" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  BPJS Ketenagakerjaan
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save()"
                  style="max-width: 60%; border-radius: 10px;"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details

                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"
                  
                  class="mb-6"
                  :color="set_color"
                  placeholder="Contoh. 324010XXXXX"
                  
                  v-model="form.bpjs_tk"
                  vvvv-uppercase
                  :success="form.bpjs_tk !== '' && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        BPJS Ketenagakerjaan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.bpjs_tk !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="jumlah_tanggungan" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Jumlah Tanggungan
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save()"
                  style="max-width: 35%; border-radius: 10px;"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details

                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"
                  
                  class="mb-6"
                  :color="set_color"
                  placeholder="Contoh. 3"
                  
                  v-model="form.jumlah_tanggungan"
                  vvvv-uppercase
                  :success="form.jumlah_tanggungan !== '' && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Jumlah Tanggungan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.jumlah_tanggungan !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="account_bank_name" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Nama Bank
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-select
                  v-on:keyup.enter="save()"
                  style="max-width: 60%; border-radius: 10px;"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. BRI"
                  hide-details
                  
                  :items="bank"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="form.account_bank_name"
                  :success="form.account_bank_name !== '' && valid"
                  :error-messages="errors">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nama Bank {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.account_bank_name !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <ValidationProvider 
                name="account_number" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Nomor Rekening
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save()"
                  style="max-width: 50%; border-radius: 10px;"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details

                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"
                  
                  class="mb-6"
                  :color="set_color"
                  placeholder="Contoh. XXXXXXXX"
                  
                  v-model="form.account_number"
                  vvvv-uppercase
                  :success="form.account_number !== '' && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nomor Rekening {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.account_number !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="account_name" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Atas Nama Rekening
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save()"
                  style="max-width: 70%; border-radius: 10px;"
                  filled
                  rounded
                  dense
                  single-line
                  hide-details

                  class="mb-6"
                  :color="set_color"
                  placeholder="Contoh. John Doe"
                  
                  v-model="form.account_name"
                  vvvv-uppercase
                  :success="form.account_name !== '' && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Atas Nama Rekening {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.account_name !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="role" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Role
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>
                
                <v-select
                  v-on:keyup.enter="save()"
                  style="max-width: 45%; border-radius: 10px;"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. Staff"
                  hide-details
                  
                  :items="[
                    {
                      text: 'Staff',
                      value: 'staff'
                    },
                    {
                      text: 'Admin',
                      value: 'admin'
                    }
                  ]"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="form.role"
                  :success="form.role !== '' && valid"
                  :error-messages="errors">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Role {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.role !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <!-- <ValidationProvider 
                name="unit_id" 
                rules="required"
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Unit
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-select
                  v-on:keyup.enter="save()"
                  style="max-width: 60%; border-radius: 10px;"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. Kantor Pusat SDM"
                  hide-details

                  disabled
                  
                  :items="list_unit"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  @change="fetchPosition(); form.position_id = ''; position = '';"

                  v-model="form.unit_id"
                  :success="form.unit_id !== '' && valid"
                  :error-messages="errors">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Unit {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.unit_id !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider> -->

              <ValidationProvider 
                name="position_id" 
                rules="required"
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Posisi
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-select
                  v-on:keyup.enter="save()"
                  style="max-width: 60%; border-radius: 10px;"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. Marketing"
                  hide-details
                  
                  :items="list_position"
                  item-text="text"
                  item-value="value"
                  :item-color="set_color"

                  v-model="form.position_id"
                  :success="form.position_id !== '' && valid"
                  :error-messages="errors">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Posisi {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.position_id !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  class="py-0">
                  <div>
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Jam Presensi Datang
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-menu
                      ref="start_time"
                      v-model="time.start"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="form.absen_start_time"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <ValidationProvider 
                          name="Jam Presensi Datang" 
                          rules="required"
                          v-slot="{ errors, valid }">
                          <v-text-field
                            v-on:keyup.enter="save"
                            readonly
                            filled
                            rounded
                            dense
                            :color="set_color"
                            placeholder="Contoh. 09:00"

                            hide-details

                            clearable
                            @click:clear="form.absen_start_time = ''; form.absen_end_time = '';"
                            v-on="on"
                            v-bind="attrs"

                            v-model="form.absen_start_time"
                            :success="valid"
                            :error-messages="errors"
                            class="mb-6"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  Jam Presensi Datang {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="form.absen_start_time !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </template>

                      <v-time-picker
                        v-if="time.start"
                        v-model="form.absen_start_time"
                        full-width
                        :color="set_color"
                        format="24hr"
                        @click:minute="$refs.start_time.save(`${form.absen_start_time}`); form.absen_end_time = '';">
                      </v-time-picker>
                    </v-menu>
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  class="py-0">
                  <div>
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Jam Presensi Pulang
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>
                    
                    <v-menu
                      ref="end_time"
                      v-model="time.end"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="form.absen_end_time"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <ValidationProvider 
                          name="Jam Presensi Pulang" 
                          rules="required"
                          v-slot="{ errors, valid }">
                          <v-text-field
                            v-on:keyup.enter="save"
                            readonly
                            filled
                            rounded
                            dense
                            :color="set_color"
                            placeholder="Contoh. 17:00"
                            
                            hide-details

                            clearable
                            @click:clear="form.absen_end_time = ''"
                            v-on="on"
                            v-bind="attrs"

                            v-model="form.absen_end_time"
                            :success="valid"
                            :error-messages="errors"
                            class="mb-6"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  Jam Presensi Pulang {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="form.absen_end_time !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </template>

                      <v-time-picker
                        v-if="time.end"
                        :min="form.absen_start_time"
                        v-model="form.absen_end_time"
                        full-width
                        :color="set_color"
                        format="24hr"
                        @click:minute="$refs.end_time.save(`${form.absen_end_time}`)">
                      </v-time-picker>
                    </v-menu>
                  </div>
                </v-col>
              </v-row>

              <div>
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Tanggal Bergabung
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-menu
                  ref="join"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="picker.join">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      name="join_date" 
                      rules="required"
                      v-slot="{ errors, valid }">
                      <v-text-field
                        v-on:keyup.enter="save"
                        readonly
                        filled
                        rounded
                        dense
                        :color="set_color"
                        placeholder="Pilih Tanggal"
                        hide-details
                        clearable

                        @click:clear="form.join_date = ''"
                        v-on="on"
                        v-bind="attrs"

                        v-model="form.join_date"
                        :success="form.join_date !== '' && valid"
                        :error-messages="errors"
                        class="mb-3"
                        style="border-radius: 10px; width: 50%;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Tanggal Bergabung {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.join_date !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-date-picker 
                    :color="set_color"
                    v-model="form.join_date"
                    @input="picker.join = false">
                  </v-date-picker>
                </v-menu>
              </div>
            </v-form>
          </ValidationObserver>

          <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-center">
              <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      @keydown.esc="dialog.delete = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hapus Data

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="body-1 font-weight-light text-first mt-3">
          Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?

          <v-card v-if="selected.node.children !== undefined && selected.node.children.length > 0"
            flat
            :color="set_color_rgb_soft"
            :style="`border: 2px solid ${set_color};`"
            class="pa-4 mt-4"
            style="border-radius: 10px;">
            <div
              class="body-2 font-weight-bold black--text mb-2">
              Catatan.
            </div>

            <div
              class="body-2"
              style="opacity: 70%;">
              Jika Anda menghapus data yang Anda pilih, maka sub data juga akan dihapus.
            </div>
          </v-card>
        </v-card-text>

        <div v-if="message.error.length > 0"
          class="text-center mx-6 my-4">
          <div
            class="error--text d-flex align-center">
            <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
            
            <span
              class="ml-1">
              {{ message.error }}
            </span>
          </div>
        </div>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.delete"
            :loading="process.delete"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.delete"
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          flat 
          style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <v-row>
              <v-col 
                cols="12" 
                md="6">
                <div
                  class="d-flex align-center">
                  <div class="mr-3">
                    <v-btn
                      @click="$router.go(-1)"
                      :color="set_color"
                      elevation="0"
                      style="border-radius: 10px;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center white--text">
                      <v-icon size="18">mdi-arrow-left-thick</v-icon>

                      <span class="ml-1">
                        Kembali
                      </span>
                    </v-btn>
                  </div>

                  <v-btn
                    :to="`/unit/structure/officer/regulation/${$route.params.id}`"
                    color="#E5E7EB"
                    elevation="0"
                    class="text-capitalize d-flex align-center"
                    style="border-radius: 10px;">
                    <v-icon>mdi-vector-polyline-edit</v-icon>

                    <span
                      class="ml-1">
                      Lihat Peraturan Unit
                    </span>
                  </v-btn>
                </div>
              </v-col>

              <v-col 
                cols="12" 
                md="6">
                <div
                  class="d-flex align-center justify-end">
                  <v-btn
                    @click="zoomIn"
                    :color="set_color"
                    fab
                    width="36"
                    height="36"
                    elevation="0"
                    class="mx-2"
                    style="border-radius: 10px;">
                    <v-icon color="white">mdi-magnify-plus-outline</v-icon>
                  </v-btn>

                  <!-- <v-btn
                    @click="capture"
                    :loading="process.caps"
                    :disabled="process.caps"
                    :color="set_color"
                    outlined
                    fab
                    width="36"
                    height="36"
                    elevation="0"
                    class="mx-2"
                    :style="`color: ${set_color};`"
                    style="border-radius: 10px;">
                    <v-icon :color="set_color">mdi-fit-to-screen-outline</v-icon>
                  </v-btn> -->

                  <v-btn
                    @click="zoomOut"
                    :color="set_color"
                    fab
                    width="36"
                    height="36"
                    elevation="0"
                    class="mx-2"
                    style="border-radius: 10px;">
                    <v-icon color="white">mdi-magnify-minus-outline</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card
            flat
            class="pa-4"
            :color="set_color_rgb_soft"
            style="border-radius: 0px;">
            <div
              class="d-flex align-center">
              <!-- <div
                style="font-weight: 600;">
                Struktur Organisasi {{ $route.query.name }}
              </div>

              <div
                class="mx-4">
                <v-divider
                  vertical
                  style="border-right: 2px solid #000000; height: 20px; opacity: 60%;" />
              </div> -->

              <div
                style="font-weight: 600;">
                <span
                  style="opacity: 60%;">
                  Total Pegawai:
                </span>

                <span>
                  {{ count.user }}
                </span>
              </div>
            </div>
          </v-card>

          <v-card-text>
            <div 
              id="tree"
              @mousewheel="deltaZoom">
              <vue-tree
                ref="tree"
                linkStyle="straight"
                direction="vertical"
                :dataset="list"
                :config="{ nodeWidth: 350, nodeHeight: 100, levelHeight: 250 }"
                :collapse-enabled="true"
                style="width: 100%; height: calc(100vh - 286px);">
                <template v-slot:node="{ node, collapsed }">
                  <v-card
                    min-width="250"
                    :class="collapsed ? '' : ''"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px; border-radius: 10px;"
                    :style="`background: linear-gradient(to right, ${set_color_rgb_down} 0%, #FFFFFF 100%);`">
                    <v-card-text
                      class="pa-3 py-1"
                      style="height: 90px;">
                      <v-list
                        dense
                        class="pa-0"
                        style="background: transparent;">
                        <v-list-item
                          class="px-0">
                          <v-list-item-avatar 
                            class="mr-3 mt-2"
                            size="36"
                            color="#FFFFFF"
                            style="border: 2px solid #FFFFFF;"
                            :style="`box-shadow: rgba(${set_color_rgb_custom}, 0.17) 0px -23px 25px 0px inset, rgba(${set_color_rgb_custom}, 0.15) 0px -36px 30px 0px inset, rgba(${set_color_rgb_custom}, 0.1) 0px -79px 40px 0px inset, rgba(${set_color_rgb_custom}, 0.06) 0px 2px 1px, rgba(${set_color_rgb_custom}, 0.09) 0px 4px 2px, rgba(${set_color_rgb_custom}, 0.09) 0px 8px 4px, rgba(${set_color_rgb_custom}, 0.09) 0px 16px 8px, rgba(${set_color_rgb_custom}, 0.09) 0px 32px 16px;`">
                            <v-img 
                              width="100%"
                              height="100%"
                              alt="umb" 
                              :src="node.image_url !== '' ? node.image_url : require('@/assets/image/member_default.jpg')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    size="20"
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-list-item-avatar>

                          <v-list-item-content
                            style="max-width: 150px;">
                            <div
                              class="body-2 font-weight-bold black--text three-line text-capitalize mb-1">
                              {{ node.name }}
                            </div>

                            <div
                              class="body-2 black--text"
                              style="opacity: 60%;">
                              {{ node.position_title }}
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card-text>

                    <v-card-text
                      class="pa-0"
                      style="position: relative; bottom: -17px;">
                      <v-row
                        align="center"
                        justify="center">
                        <v-col v-if="user.role !== 'viewer'"
                          cols="2"
                          class="pa-0">
                          <v-btn
                            @click.stop="toAdd(node, $event)"
                            block
                            :color="set_color"
                            elevation="0"
                            class="px-0"
                            style="border-radius: 8px 0px 0px 8px;">
                            <v-icon small color="white">mdi-plus-circle-multiple-outline</v-icon>
                          </v-btn>
                        </v-col>

                        <v-col v-if="user.role !== 'viewer'"
                          cols="2"
                          class="pa-0">
                          <v-btn
                            @click.stop="toEdit(node, $event)"
                            block
                            :color="set_color"
                            elevation="0"
                            class="px-0"
                            style="border-radius: 0px; border-left: 1px solid #FFFFFF;">
                            <v-icon small color="white">mdi-circle-edit-outline</v-icon>
                          </v-btn>
                        </v-col>

                        <v-col v-if="user.role !== 'viewer'"
                          cols="2"
                          class="pa-0">
                          <v-btn
                            @click.stop="toDelete(node, $event)"
                            block
                            :color="set_color"
                            elevation="0"
                            class="px-0"
                            style="border-radius: 0px 8px 8px 0px; border-left: 1px solid #FFFFFF;">
                            <v-icon small color="white">mdi-delete-circle-outline</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </template>
              </vue-tree>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import VueTree from "@ssthouse/vue-tree-chart";
  import { get, post, put, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          fullscreen: false,
          snackbar: false,
          form: false,
          delete: false
        },
        
        selected: {
          node: {},
          delete: []
        },

        list: [],
        list_unit: [],
        list_position: [],
        bank: [
          {
            text: 'BRI',
            value: 'BRI',
            icon: require('@/assets/bank/bri.png')
          },
          {
            text: 'BNI',
            value: 'BNI',
            icon: require('@/assets/bank/bni.png')
          },
          {
            text: 'Mandiri',
            value: 'Mandiri',
            icon: require('@/assets/bank/mandiri.png')
          },
          {
            text: 'BCA',
            value: 'BCA',
            icon: require('@/assets/bank/bca.png')
          },
          {
            text: 'BSI',
            value: 'BSI',
            icon: require('@/assets/bank/bsi.png')
          },
          {
            text: 'CIMB',
            value: 'CIMB',
            icon: require('@/assets/bank/cimb.png')
          },
          {
            text: 'BTN',
            value: 'BTN',
            icon: require('@/assets/bank/btn.png')
          },
          {
            text: 'Genius',
            value: 'Genius',
            icon: require('@/assets/bank/genius.png')
          },
          {
            text: 'Danamon',
            value: 'Danamon',
            icon: require('@/assets/bank/danamon.png')
          },
          {
            text: 'Bukopin',
            value: 'Bukopin',
            icon: require('@/assets/bank/bukopin.png')
          },
          {
            text: 'Permata',
            value: 'Permata',
            icon: require('@/assets/bank/permata.png')
          }
        ],

        count: {
          user: 0
        },

        picker: {
          birth: false,
          join: false
        },

        form: {
          id: '',
          name: '',
          username: '',
          code: '',
          email: '',
          mobilephone: '',
          birthplace: '',
          birthdate: '',
          gender: '',
          blood_group: '',
          address: '',
          nik: '',
          npwp: '',
          bpjs_kes: '',
          bpjs_tk: '',
          jumlah_tanggungan: '',
          account_bank_name: '',
          account_number: '',
          account_name: '',
          unit_id: '',
          role: '',
          position_id: '',
          position: '',
          join_date: '',

          absen_start_time: '',
          absen_end_time: ''
        },

        time: {
          start: false,
          end: false
        },

        check_code: '',

        position_par_id: '',

        process: {
          load: false,
          form: false,
          delete: false,
          caps: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      VueTree
    },
    computed: {
      user () {
        return this.$store.state.user
      },

      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_custom () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `${r}, ${g}, ${b}`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+70}, ${g+91}, ${b+34})`
      }
    },
    watch: {
      'form.position_id': function(val) {
        let data = this.list_position.filter(function(v) {
          return val === v.value
        })

        if (data.length > 0) {
          this.form.position = data[0].text
        }
      }
    },
    mounted () {
      this.fetch()
      this.fetchUser()
    },
    methods: {
      async fetch () {
        this.process.load = true

        let params = {
          // limit: 100000,
          position_unit_id: this.$route.params.id
        }

        await get('admin/user/position', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.list = this.changeData(res.results.data)
          }
        })
      },

      async fetchUser () {
        let params = {
          unit_id: this.$route.params.id
        }
        
        await get('admin/user',{params})
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.count.user = res.results.pagination.total_data
          }
        })
      },

      async fetchCheck (val) {
        let params = {
          search: val
        }

        this.selected.row = []

        await get('admin/user', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let total = res.results.data.length

            this.check_code = total > 0 ? 'sudah digunakan' : ''
          }
        })
      },

      async fetchUnit () {
        let params = {
          limit: 100000
        }

        this.list_unit = []

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data.map(obj => {
              this.list_unit.push({
                text: obj.name,
                value: obj.id
              })
            })
          }
        })
      },
      async fetchPosition () {
        let params = {
          limit: 100000,
          unit_id: this.form.unit_id,
          par_id: this.position_par_id
        }

        this.list_position = []

        await get('admin/user_position', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data.map(obj => {
              this.list_position.push({
                text: obj.title,
                value: obj.id
              })
            })
          }
        })
      },

      changeData (data_array) {
        function filter (array, condition) {
          let result = []

          for (let i = 0; i < array.length; i++) {
            if (condition(array[i])) {
              result.push(array[i])
            }
          }

          return result
        }

        function getChilds (parentKey, items) {
          let subItems = filter(items, function (n) {
            return n.position_par_id === parentKey
          })

          let result = []

          for (let i = 0; i < subItems.length; i++) {
            let subItem = subItems[i]

            let kids = getChilds(subItem.position_id, items)
            if (kids.length) {
              subItem.children = kids
            }

            result.push(subItem)
          }

          if (parentKey.length) {
            return result
          } else {
            return result[0]
          }
        }

        const data = data_array

        let richMediaData = getChilds('0', data)

        return richMediaData
      },

      deltaZoom(event) {
        if (event.deltaY < 0) {
          this.$refs.tree.zoomIn()
        } else {
          this.$refs.tree.zoomOut()
        }
      },
      zoomIn () {
        this.$refs.tree.zoomIn()
      },
      zoomOut () {
        this.$refs.tree.zoomOut()
      },

      toAdd(node, event) {
        if (this.$refs.form) this.$refs.form.reset()

        this.dialog.form = true

        this.form = {
          id: '',
          name: '',
          username: '',
          code: '',
          email: '',
          mobilephone: '',
          birthplace: '',
          birthdate: '',
          gender: '',
          blood_group: '',
          address: '',
          nik: '',
          npwp: '',
          bpjs_kes: '',
          bpjs_tk: '',
          jumlah_tanggungan: '',
          account_bank_name: '',
          account_number: '',
          account_name: '',
          unit_id: this.$route.params.id,
          role: '',
          position_id: '',
          position: '',
          join_date: '',

          absen_start_time: '',
          absen_end_time: ''
        }

        this.time = {
          start: false,
          end: false
        }

        this.picker = {
          birth: false,
          join: false
        }

        this.process.form = false

        this.message.error = ''

        console.log(node)

        this.position_par_id = node.position_par_id

        this.fetchUnit()
        this.fetchPosition()
      },
      async toEdit(node, event) {
        let params = {
          id: node.id
        }

        await get('admin/user/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            let item = res.results.data

            if (this.$refs.form) this.$refs.form.reset()
            
            this.dialog.form = true

            this.form = {
              id: item.id,
              name: item.name,
              username: item.username,
              code: item.code,
              email: item.email,
              mobilephone: item.mobilephone,
              birthplace: item.birthplace,
              birthdate: item.birthdate,
              gender: item.gender,
              blood_group: item.blood_group,
              address: item.address,
              nik: item.nik,
              npwp: item.npwp,
              bpjs_kes: item.bpjs_kes,
              bpjs_tk: item.bpjs_tk,
              jumlah_tanggungan: item.jumlah_tanggungan,
              account_bank_name: item.account_bank_name,
              account_number: item.account_number,
              account_name: item.account_name,
              unit_id: item.unit_id,
              role: item.role,
              position_id: item.position_id,
              position: item.position,
              join_date: item.join_date,

              absen_start_time: item.absen_start_time,
              absen_end_time: item.absen_end_time
            }

            this.time = {
              start: false,
              end: false
            }

            this.picker = {
              birth: false,
              join: false
            }

            this.process.form = false

            this.message.error = ''

            console.log(node)

            this.position_par_id = node.position_par_id

            this.fetchUnit()
            this.fetchPosition()
          }
        })

      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id.length < 1 ? 'admin/user/add' : 'admin/user/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetch()

              this.fetchUser()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete(node, event) {
        this.selected.delete = []

        this.selected.node = node

        this.selected.delete.push(parseInt(node.id))

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post('admin/user/delete', {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {
            this.dialog.delete = false

            this.selected.node = {}
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()

            this.fetchUser()
          } else {
            this.message.error = res.message
          }
        })
      },

      async capture () {
        this.process.caps = true

        let self = this,
            data = document.getElementById('tree')

        await this.$html2canvas(data, {
          logging: true,
          letterRendering: true,
          allowTaint: false,
          useCORS: true,

          scale: 1920*2/window.innerWidth,

          scrollX: 0,
          scrollY: 0,

          width: 1920,
          height: 1080,
          windowWidth: 7680,
          windowHeight: 4320
        })
        .then(function(canvas) {
          document.body.appendChild(canvas)

          let img = canvas.toDataURL('image/png', 1.0), a = document.createElement('a')

          a.href = img
          a.download = `Pakualaman-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.png`
          a.click()

          self.process.caps = false
        })
      }
    }
  }
</script>